<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>Domener</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="domain-list" key="domain-list" />

        <v-data-table
          :headers="headers"
          :items="domains"
          hide-actions
          class="elevation-1"
          item-key="domain"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <router-link class="big-link" :to="{ 'name': 'domain-detail', params: { domain: props.item.domain } }">
                {{ props.item.unicode_domain }}
              </router-link>
            </td>
          </template>
        </v-data-table>

        <v-list v-if="domains_without_dns.length" class="elevation-1">
          <v-subheader class="has-big-non-links">
            Domener uten DNS - kontakt info@mekke.no ang. disse
          </v-subheader>
          <v-list-tile
            v-for="(domain, index) in domains_without_dns"
            :key="index"
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="domain" class="big-non-link"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DomainService from '@/services/DomainService'

export default {
  name: 'domain-list',
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      headers: [
        { text: 'Domene', sortable: false, class: 'has-big-links' }
      ],
      domains: [],
      domains_without_dns: []
    }
  },
  methods: {
    async init () {
      const punycode = require('punycode')
      const response = await this.runService(this, 'domain-list', DomainService.getList)
      var i = 0
      var j = 0

      if (response) {
        this.domains = response.data.sort(function (a, b) {
          return a['domain'].localeCompare(b['domain'])
        })

        for (i = 0; i < this.domains.length; ++i) {
          this.domains[i]['unicode_domain'] = punycode.toUnicode(this.domains[i]['domain'])
        }
      }

      const response2 = await this.runService(this, 'domain-list', DomainService.getCompleteList)
      if (response2) {
        var allDomains = response2.data
        var found = false

        for (i = 0; i < allDomains.length; ++i) {
          found = false

          for (j = 0; j < this.domains.length; ++j) {
            if (allDomains[i] === this.domains[j]['domain']) {
              found = true
              continue
            }
          }

          if (found === false) {
            this.domains_without_dns.push(punycode.toUnicode(allDomains[i]))
          }
        }

        this.domains_without_dns = this.domains_without_dns.sort()
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 340px !important;
  font-size: 1.2em;
}

.card .v-btn {
  font-size: 1em;
}
</style>
